import React from "react";
import { ButtonLocation } from "../../util/use-ga/event";
import { useGA4 } from "../../util/use-ga";
import { SocialIconBox, ImgContainer, IconLink } from "./elements";
import { FaTwitter, FaDiscord } from "react-icons/fa"

interface Props {
    isDark?: boolean
    buttonLocation: ButtonLocation
}

const SocialIcons: React.FC<Props> = ({ isDark = false, buttonLocation }) => {
    const { event } = useGA4()

    return (
        <SocialIconBox>
            <IconLink
                target="_blank"
                href="https://twitter.com/MoonvilleFarms"
                onClick={() => {
                    event("Twitter Button Clicked", { button_location: buttonLocation })
                }}
            >
                <ImgContainer dark={String(isDark)}>
                    <FaTwitter />
                </ImgContainer>
            </IconLink>

            <IconLink
                target="_blank"
                href="https://discord.com/invite/myria"
                onClick={() => {
                    event("Discord Button Clicked", { button_location: buttonLocation })
                }}
            >
                <ImgContainer dark={String(isDark)}>
                    <FaDiscord />
                </ImgContainer>
            </IconLink>
        </SocialIconBox>
    )
}

export default SocialIcons;